import { Reveal } from "@/lib/motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/site";

export const FAQ = () => (
  <section data-testid="faq" className="section-pad bg-white">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-[#999999] mb-6 font-mono">FAQ</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#111111]">
            Questions, Answered.
          </h2>
        </Reveal>
      </div>
      <div className="lg:col-span-8">
        <Reveal>
          <Accordion type="single" collapsible defaultValue="item-0" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[#E0E0E0]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-6 text-left font-serif text-xl md:text-2xl text-[#111111] hover:no-underline">
                  <span className="flex items-start gap-4 w-full pr-4">
                    <span className="font-mono text-xs text-[#999999] mt-2 shrink-0">0{i + 1}</span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-8 pl-8 text-base md:text-lg text-[#666666] leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
